import { LatestWork } from './components'

const HomeLeftSidebar = () => <LatestWork />

export { HomeLeftSidebar }
